import { BlogEntry } from '@/views/blog/models/Blog';
import { orderBy } from 'lodash';

export const shouldShowPartnerProgramCard = ({
  isFreelancer,
  hasAffiliateAccess,
  hasAffiliateConsent,
}: {
  isFreelancer: boolean;
  hasAffiliateAccess: boolean;
  hasAffiliateConsent: boolean | null | undefined;
}) => isFreelancer && hasAffiliateAccess && hasAffiliateConsent === false;

export const getDashboardBlogMode = (showPartnerProgramCard: boolean) => (
  showPartnerProgramCard ? 'mixed' : 'articles'
);

export const mergeDashboardBlogEntries = (entries: BlogEntry[]) => {
  const featuredEntries = orderBy(
    entries.filter((entry) => entry.position === 1),
    ['publishDate'],
    ['desc'],
  );
  const otherEntries = orderBy(
    entries.filter((entry) => entry.position !== 1),
    ['publishDate'],
    ['desc'],
  );

  return [...featuredEntries, ...otherEntries];
};
